import LocalizedStrings from 'localized-strings';

export const locales = new LocalizedStrings({
  en: {
    externalStandardTransferCardDescription:
      'Reception within 2 to 3 working days.',
    externalStandardTransferCardTitle: 'Standard',
    externalStandardTransferTooltipDescription:
      'This transfer cannot be instantaneous. This may be due to the beneficiary bank, your limit, the amount or other factors.',
    instantTransferCardDescription: 'No extra charge.',
    instantTransferCardTitle: 'Instant',
    instantTransferTooltipDescription:
      'If eligible, your transfers are by default instant and at no extra cost, meaning your beneficiary will receive the funds in seconds.',
    internalTransferCardDescription: 'Instant, free, and unlimited.',
    internalTransferCardTitle: 'Internal',
    internalTransferTooltipDescription:
      'Internal transfers to your Shine accounts are always instant: they are credited in a few seconds.',
    scheduledTransferCardDescription:
      'Reception within 2 to 3 working days after the date of issue.',
    scheduledTransferCardTitle: 'Scheduled',
    scheduledTransferTooltipDescription:
      'Your scheduled transfers are standard transfers and will be received by your beneficiary within 2 to 3 working days after the date of issue.',
    title: 'Type of transfer',
  },
  fr: {
    externalStandardTransferCardDescription:
      'Réception sous 2 à 3 jours ouvrés.',
    externalStandardTransferCardTitle: 'Standard',
    externalStandardTransferTooltipDescription:
      'Ce virement ne peut pas être instantané. Ceci peut être dû à la banque bénéficiaire, votre plafond, au montant ou d’autres facteurs.',
    instantTransferCardDescription: 'Sans frais supplémentaires.',
    instantTransferCardTitle: 'Instantané',
    instantTransferTooltipDescription:
      'Si éligibles, vos virements sont par défaut instantanés et sans frais supplémentaires, ce qui signifie que votre bénéficiaire recevra les fonds en quelques secondes.',
    internalTransferCardDescription: 'Instantané, gratuit et illimité.',
    internalTransferCardTitle: 'Interne',
    internalTransferTooltipDescription:
      'Les virements internes à vos comptes Shine sont toujours instantanés : ils sont crédités en quelques secondes.',
    scheduledTransferCardDescription:
      'Réception sous 2 à 3 jours ouvrés après la date d’émission.',
    scheduledTransferCardTitle: 'Programmé',
    scheduledTransferTooltipDescription:
      'Vos virements programmés sont des virements standards, ils seront reçus par votre bénéficiaire sous 2 à 3 jours ouvrés après la date d’émission.',
    title: 'Type de virement',
  },
} as const);
